module.exports = __webpack_public_path__ + "static/img/balance_v2_icon.93ce9552.png";